import Notifications from "@/views/settings/Notifications";
import ProductList from "@/views/settings/ProductList";
import ProfileSettings from "@/views/settings/ProfileSettings";
import CompanySettings from "@/views/settings/CompanySettings";
import InvoiceSettings from "@/views/settings/InvoiceSettings";
import InvoiceDesignMobile from "@/views/settings/InvoiceDesignMobile";
import LogoGeneratorMobile from "@/views/settings/LogoGeneratorMobile";
import CostTypesSettings from "@/views/settings/CostTypesSettings";
import Cars from "@/views/settings/Cars";
import Team from "@/views/settings/Team";
import Brands from "@/views/settings/Brands";
import Subscriptions from "@/views/settings/Subscriptions";
import PaymentDetails from "@/views/settings/PaymentDetails";
import DowngradeSubscription from "@/views/settings/DowngradeSubscription";
import ConfirmPayment from "@/views/settings/ConfirmPayment";
import PaymentComplete from "@/views/settings/PaymentComplete";
import IdealPayments from "@/views/settings/IdealPayments";
import BankSettings from "@/views/settings/BankSettings";
import ImportData from "@/views/settings/ImportData";
import DownloadData from "@/views/settings/DownloadData";
import Webshop from "@/views/settings/Webshop";
import AccountDelete from "@/views/settings/AccountDelete";
import ChangePassword from '@/views/settings/ChangePassword'
import CreateCompany from "@/views/settings/CreateCompany";
// import BankConnection from "@/views/settings/BankConnection";
import GiveFreeMonth from "@/views/settings/GiveFreeMonth";
import VerifactuSettings from "@/views/settings/VerifactuSettings";
import PeppolSettings from "@/views/settings/PeppolSettings";
import Files from "@/views/gekko/Files.vue";
import Layouts from "@/views/settings/Layouts";

const routeOptions = [
  { path: "/:language/comm/notifications", name: "Notifications", component: Notifications, meta: { title: 'Notification settings' } },
  { path: "/:language/products", name: "ProductList", component: ProductList, meta: { title: 'My Products' } },
  { path: "/:language/accounts/profile", name: "ProfileSettings", component: ProfileSettings, meta: { title: 'My Personal Profile' } },
  { path: "/:language/accounts/company/add", name: "CreateCompany", component: CreateCompany, meta: { title: 'Create company' } },
  { path: "/:language/accounts/companies", name: "CompanySettings", component: CompanySettings, meta: { title: 'Change your company details' } },
  { path: "/:language/accounts/brands", name: "Brands", component: Brands, meta: { title: 'Change your brands details' } },
  { path: "/:language/accounts/layout-builder", name: "Layouts", component: Layouts, meta: { title: 'Create your own layout' } },
  { path: "/:language/accounts/invoice", name: "InvoiceSettings", component: InvoiceSettings, meta: { title: 'Invoice settings' } },
  { path: "/:language/accounts/verifactu", name: "VerifactuSettings", component: VerifactuSettings, meta: { title: 'Verifactu settings' } },
  { path: "/:language/accounts/peppol", name: "PeppolSettings", component: PeppolSettings, meta: { title: 'Peppol settings' } },
  {
    path: '/:language/accounts/invoice/design/', name: 'InvoiceDesignMobile', component: InvoiceDesignMobile, meta: { title: 'Invoice design' }, children: [
      { path: ':brand_id', name: 'InvoiceDesignMobile', meta: { title: 'Invoice design' } }
    ]
  },
  {
    path: '/:language/accounts/logo-generator-mobile/',
    name: 'LogoGeneratorMobile',
    component: LogoGeneratorMobile,
    meta: {
      title: 'Logo generator'
    }, children: [
      { path: ':brand_id', name: 'LogoGeneratorMobile', meta: { title: 'Logo generator' } }
    ]
  },
  { path: "/:language/accounts/bank-settings", name: "BankSettings", component: BankSettings, meta: { title: 'Bank Settings' } },
  { path: "/:language/accounts/cost-types", name: "CostTypesSettings", component: CostTypesSettings, meta: { title: 'Company cost categories' } },
  { path: "/:language/accounts/cars", name: "Cars", component: Cars, meta: { title: 'Your cars' } },
  { path: "/:language/accounts/data/import", name: "ImportData", component: ImportData, meta: { title: 'Import your data' } },
  { path: "/:language/accounts/team", name: "Team", component: Team, meta: { title: 'Team' } },
  { path: "/:language/accounts/data/download", name: "DownloadData", component: DownloadData, meta: { title: 'Download your data' } },
  { path: "/:language/accounts/webshop", name: "Webshop", component: Webshop, meta: { title: 'Webshop' } },
  { path: "/:language/subscriptions/manage/", name: "Subscriptions", component: Subscriptions, meta: { title: 'Manage your subscription' } },
  { path: "/:language/subscriptions/payment-details", name: "PaymentDetails", component: PaymentDetails, meta: { title: "Manage your subscription" } },
  { path: "/:language/subscriptions/downgrade/", name: "DowngradeSubscription", component: DowngradeSubscription, meta: { title: 'Manage your subscription' }, },
  { path: "/:language/subscriptions/confirm-payment/:transactionId", name: "ConfirmPayment", component: ConfirmPayment, meta: { title: 'Manage your subscription' } },
  { path: "/:language/subscriptions/payment-complete-new/", name: "PaymentComplete", component: PaymentComplete, meta: { title: 'Manage your subscription' } },
  { path: "/:language/accounts/ideal-payment", name: "IdealPayments", component: IdealPayments, meta: { title: 'iDEAL Payments' } },
  { path: "/:language/accounts/delete", name: "AccountDelete", component: AccountDelete, meta: { title: 'Delete My Personal Profile' } },
  { path: "/:language/accounts/change/password", name: "ChangePassword", component: ChangePassword, meta: { title: 'ChangePassword' } },
  // { path: "/:language/accounts/bank-connection", name: "BankConnection", component: BankConnection, meta: { title: 'Bank Connection' } },
  { path: "/:language/subscriptions/give_free_month", name: "GiveFreeMonth", component: GiveFreeMonth, meta: { title: 'Give Free Month' } },
  {
    path: '/:language/accounts/files', component: Files, name: 'Files', meta: { title: 'Files' }, children: [
      { path: '/:language/accounts/files/:id', component: Files, name: 'FileDetails', meta: { title: 'File details', showModal: true }, },
    ],
  },
]
export default routeOptions
